import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  "navTheme": "light",
  "colorPrimary": "#13C2C2",
  "layout": "top",
  "contentWidth": "Fixed",
  "fixedHeader": true,
  "fixSiderbar": true,
  "splitMenus": false,
  title: ' ',
  pwa: true,
  logo: 'https://sequilern.com/static/media/logo.53dc6c949dd243c4283c89d72105eeb4.svg',
  iconfontUrl: '',
  token: {
    bgLayout: 'transparent',
    pageContainer: {
      colorBgPageContainer: 'transparent',
      paddingBlockPageContainerContent: 0,
    },
  },
};

export default Settings;
